import React from 'react';

import PropTypes from 'prop-types';

import {
  Text
} from '../../../StyledComponents';

export const AddressTitleTuple = (props) => {

  return (
    <div>
      <Text
        lineheight="2"
        fontWeight="500">

        {props.title}
      </Text>

      <Text color="#666">

        {props.subtitle}
      </Text>
    </div>
  );
};

AddressTitleTuple.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
};
